<template>
  <div class="order-detail">
    <div class="status-content">取消订单</div>
    <div class="content">
      <div class="header"><span class="red">*</span><span>取消原因</span></div>
      <div class="tips">取消成功将自动退款到原账户</div>
      <van-radio-group icon-size="16px" checked-color="#FE5756" v-model="reason">
        <van-radio name="订单信息拍错（日期、份数、商品等）">订单信息拍错（日期、份数、商品等）</van-radio>
        <van-radio name="商品与描述不符">商品与描述不符</van-radio>
        <van-radio name="地址/电话信息填写错误">地址/电话信息填写错误</van-radio>
        <van-radio name="其他原因">其他原因</van-radio>
        <van-field v-if="reason === '其他原因'" type="textarea" v-model="reasonText" placeholder="请输入原因" rows="2" maxlength="20" show-word-limit @input="validateInput" />
      </van-radio-group>
      <div v-if="reason === '其他原因' && showTips" class="tips red">禁止输入除#@%￥&*·（）&lt; &gt;《》'“”‘’/〇.I~XI以外的特殊字符</div>
    </div>
    <div class="footer">
      <van-button type="danger" block @click="cancelPayOrderSubmit()">提交</van-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        reason: '',
        reasonText: '',
        showTips: false
      }
    },
    created() {
      let { orderId } = this.$route.query
    },
    methods: {
      validateInput(val) {
        if (val && !/^[a-zA-Z0-9\u4e00-\u9fa5#@%￥&*·（）<>《》'“”‘’/〇.IIIIIIIVVVIVIIVIIIIXXXI]+$/.test(val)) {
          this.showTips = true
        } else {
          this.showTips = false
        }
      },
      // 取消订单
      cancelPayOrderSubmit() {
        if (!this.reason && this.reason !== '其他原因') {
          this.$toast('请选择取消原因')
          return
        }
        if (this.reason === '其他原因' && !this.reasonText) {
          this.$toast('请输入原因')
          return
        }
        if (this.reason === '其他原因' && this.showTips) {
          return
        }
        let { orderId } = this.$route.query
        let params = {
          orderId,
          reason: this.reason && this.reason !== '其他原因' ? this.reason : this.reasonText
        }
        this.$api.userCentered.cancelOrder(params).then((res) => {
          let { message } = res
          this.$toast(message)
          this.$router.replace({ name: 'OrderDetail', query: { orderId } })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .order-detail {
    .content {
      background: #fff;
      padding: 1rem;
      .header {
        color: #040404;
        font-size: 0.88rem;
        font-weight: 500;
        .red {
          color: #fe5756;
          margin-right: 0.2rem;
        }
      }
      .tips {
        margin-top: 0.5rem;
        margin-bottom: 1rem;
        font-weight: 400;
        font-size: 0.75rem;
        color: #999999;
      }
      .red {
        color: #fe5756;
      }
      .van-radio {
        margin-bottom: 0.8rem;
        font-weight: 400;
        font-size: 14px;
        color: #040404;
      }
      .van-field {
        border: 1px solid #999999;
        font-size: 14px;
        color: #999999;
        border-radius: 0.13rem;
        .van-field__word-limit {
          color: #999999;
        }
      }
    }
    .footer {
      margin: 1.25rem 1.2rem;
      .van-button.van-button--danger {
        height: 2.56rem;
        background-color: #fe5756;
        border-color: #fe5756;
        border-radius: 0.13rem;
      }
    }
    .status-content {
      margin: 1rem;
      text-align: center;
      font-weight: 500;
      font-size: 1rem;
      color: #333333;
      position: relative;
    }
  }
</style>
